<template>
  <div class="type-group">
    <div v-if="type !== 'leftOneRightThree'" class="type-box" :class="type">
      <div
        v-for="i in length"
        :key="i"
        @click="$emit('input', i)"
        :class="{ active: i === value }"
      >
        {{ showText }}
      </div>
    </div>

    <!-- 最后一种实现需要嵌套 -->
    <div class="type-box" :class="type" v-else>
      <div @click="$emit('input', 1)" :class="{ active: 1 === value }">
        {{ showText }}
      </div>
      <div>
        <div
          v-for="i in length - 1"
          :key="i"
          @click="$emit('input', i + 1)"
          :class="{ active: i + 1 === value }"
        >
          {{ [2, 3].includes(i) ? "宽度187.5像素" : showText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: "0"
    },
    type: {
      type: String,
      default: "oneLineOne"
    },
    length: {
      type: Number,
      default: 1
    }
  },
  computed: {
    widthText() {
      return {
        oneLineOne: "750",
        oneLineTwo: "375",
        oneLineThree: "250",
        oneLineFour: "187.5",
        leftOneRightTwo: "375",
        leftTwoRightOne: "375",
        leftOneRightThree: "375"
      }[this.type];
    },
    showText() {
      return `宽度${this.widthText}像素`;
    }
  }
};
</script>

<style lang="less" scoped>
.type-group {
  padding: 0;
  width: 330px;
  height: 165px;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .type-box {
    display: flex;
    div {
      border: 1px solid #eeeeee;
      cursor: pointer;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
  }
  .oneLineOne {
    > div {
      width: 330px;
      height: 165px;
    }
  }
  .oneLineTwo {
    > div {
      width: 165px;
      height: 165px;
    }
  }

  .oneLineThree {
    > div {
      width: 110px;
      height: 165px;
    }
  }

  .oneLineFour {
    > div {
      width: 82.5px;
      height: 165px;
    }
  }

  .leftOneRightTwo,
  .leftTwoRightOne {
    width: 330px;
    height: 165px;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: 165px;
      height: 82.5px;
    }
    > div:first-child {
      height: 165px;
    }
  }

  .leftTwoRightOne {
    flex-direction: column-reverse;
    flex-wrap: wrap-reverse;
  }

  .leftOneRightThree {
    > div:first-child {
      width: 165px;
      height: 165px;
    }
    > div:last-child {
      width: 165px;
      display: flex;
      flex-wrap: wrap;
      border: none;
      > div:first-child {
        width: 165px;
        height: 82.5px;
      }
      > div:nth-child(2),
      div:last-child {
        width: 82.5px;
        height: 82.5px;
      }
    }
  }
}

.active {
  background: #e2edfd;
  color: #2154f4 !important;
  border: 1px solid #2154f4 !important;
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Cube/components/TypeViewGroup.vue